import * as urls from '../routePaths';
import { getRedirectParam } from './getRedirectParam';

/* istanbul ignore file */

export const getRedirectUrl = (): string => {
  const redirectTo = getRedirectParam();
  return redirectTo ? decodeURIComponent(redirectTo) : urls.PROFILE_URL;
};
